export default __webpack_public_path__ + "static/media/a011-startup-03.13863c91.svg";